import { render, staticRenderFns } from "./repdj.vue?vue&type=template&id=5e36fd03&"
import script from "./repdj.vue?vue&type=script&lang=js&"
export * from "./repdj.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports